<template>
  <div class="dashboard-layout">
    <a href="#main-content" class="skip-link">{{ $t("a11y.skipToContent") }}</a>
    <notifications></notifications>

    <div class="layout-container" :class="{ 'desktop-layout': !isMobile }">
      <simple-sidebar ref="sidebar" />

      <div class="content-container">
        <simple-topbar
          @toggle-sidebar="toggleSidebar"
          :sidebar-open="sidebarOpen"
        />

        <v-main
          id="main-content"
          tabindex="-1"
          class="main-content"
          :class="{ 'with-footer': !$route.meta.hideFooter }"
        >
          <dashboard-content />
          <content-footer v-if="!$route.meta.hideFooter" />
        </v-main>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSidebar from "@/components/SimpleSidebar.vue";
import SimpleTopbar from "@/components/SimpleTopbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";

export default {
  name: "DashboardLayout",
  components: {
    SimpleSidebar,
    SimpleTopbar,
    DashboardContent,
    ContentFooter,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    sidebarOpen() {
      return this.$refs.sidebar ? this.$refs.sidebar.showSidebar : false;
    },
  },
  watch: {
    // SPA route focus management: land keyboard/screen-reader users on the
    // new page's content instead of leaving focus on the link they clicked.
    "$route.path"() {
      this.$nextTick(() => {
        const main = document.getElementById("main-content");
        if (main) {
          main.focus();
        }
      });
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 960;
    },
    toggleSidebar() {
      if (this.$refs.sidebar) {
        this.$refs.sidebar.toggleSidebar();
      }
    },
  },
};
</script>

<style scoped>
.dashboard-layout {
  min-height: 100vh;
}

.layout-container {
  display: flex;
  min-height: 100vh;
  align-items: stretch;
}

.desktop-layout {
  flex-direction: row;
}

.content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.main-content {
  flex: 1;
  background-color: rgb(var(--v-theme-background));
}

/* The footer is position:fixed, so reserve room for it here instead of
   per-page padding hacks. */
.main-content.with-footer {
  padding-bottom: 70px;
}

@media (max-width: 959px) {
  .layout-container {
    flex-direction: column;
  }
}
</style>
